module.exports = __webpack_public_path__ + "img/item5.bf5256e4.svg";